export default {
  white: 'rgba(255,255,255,1)',
  offWhite: 'rgba(223,220,196,1)' /*  OLD 'rgba(245,225,226,1)' */,
  offBlack: 'rgba(0,0,0,0.8)',
  black: 'rgba(0,0,0,1)',
  primary: 'rgba(70,190,233,1)', //light blue
  secondary1: 'rgba(22,25,41,1)', //dark blue
  secondary2: 'gold', //'rgba(236, 227,49,1)', //gold
};
